<template>

  <VUEModal :Titolo="GetTraduzioneLabel('Generic', 'TKN_SELEZ_DATA_ALL', LinguaUtente)"
            Altezza="140px" 
            Larghezza="500px" 
           :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
           @onClickChiudiModal="AnnullaAllineamento()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <p style="width: 22%; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_SCEGLI_DATA',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:32%" step="1" type="date" v-model="ObjAllineamento.DataAllineamento">
          <div v-if="ObjAllineamento.ListaOre.length > 0" style="float:left; width:2%;">&nbsp;</div>
          <select v-if="ObjAllineamento.ListaOre.length > 0" class="form-control" style="float:left; width:18%;" v-model="ObjAllineamento.OrarioAllineamento">
            <option v-for="Ora in ObjAllineamento.ListaOre" :key="Ora" :value="Ora">{{Ora}}</option>
          </select>
          <div v-if="ObjAllineamento.ListaOre.length > 0" style="float:left; width:2%;">&nbsp;</div>
          <button v-if="ObjAllineamento.DataAllineamento != null" type="button" class="btn btn-info" style="font-weight:bold;width:24%;padding: 2px;font-size: 12px;" @click="TrovaCampioniAllineamento()">{{ this.GetTraduzioneLabel('Generic','TKN_CERCA_CAMP',this.LinguaUtente) }}</button>
          <div v-else style="width: 24%">&nbsp;</div>
        </div>
        <div v-if="InAttesaDeiDati" style="margin-top: 10px;" :style="{'color' : Arancione}">
          <p style="width: 100%; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_RICERCA_IN_CORSO',this.LinguaUtente) }}...</p>
        </div>
        <div v-if="!ObjAllineamento.Dati && !InAttesaDeiDati" style="margin-top: 10px; color: red">
          <p style="width: 100%; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_ALL_NON_TROVATO',this.LinguaUtente) }}</p>
        </div>       
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaAllineamento()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjAllineamento.DataAllineamento != null && ObjAllineamento.OrarioAllineamento != null && ObjAllineamento.Dati" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaAllineamento()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

</template>

<script>
import VUEModal from '@/utils/VUEModal.vue';
import { SystemInformation } from '../../SystemInformation.js'
import MixInsDoubleClickHandler from '@/views/ContentPages/MixInsDoubleClickHandler';
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';

class TOggettoDataAllineamento
{
  constructor()
  {
    this.DataAllineamento       = null
    this.OrarioAllineamento     = null
    this.ListaOre               = []
    this.DataOraAllineamento    = null
    this.PrettyDataAllineamento = ''
    this.NuovaDataAllineamento  = ''
    this.AllineaTemperatura     = false
    this.Dati                   = true
  }
} 

export default
{
  components: 
  {
    VUEModal,
  },
  props: ["ChiaveSito"],
  emits: ["onClickConfermaAllineamento", 'onClickAnnullaPopupAllineamento'],
  mixins: [MixInsDoubleClickHandler, MixInsGestioneTraduzioni],
  data() 
  {
    return  {
                ObjAllineamento : new TOggettoDataAllineamento(),
                InAttesaDeiDati : false,
                LinguaUtente    : SystemInformation.UserInformation.Lingua
            }
  },

  computed :
  {

  },

  methods: 
  {
    ConfermaAllineamento()
    {
      this.$emit('onClickConfermaAllineamento', this.ObjAllineamento )
      this.AnnullaAllineamento()
    },

    AnnullaAllineamento()
    {
      this.$emit('onClickAnnullaPopupAllineamento')
    },

    TrovaCampioniAllineamento()
    {
      if(!this.InAttesaDeiDati)
      {
        this.InAttesaDeiDati = true
        this.ObjAllineamento.ListaOre = []
        let Self = this
        let Dal = this.ObjAllineamento.DataAllineamento + ' 00:00:00' 
        let Al  = this.ObjAllineamento.DataAllineamento + ' 23:59:59'
        SystemInformation.AdvQuerySiti.GetSQL("Catene",{Dal : Dal, Al : Al, DMSEWSito : this.ChiaveSito},
                                                function(Results)
                                                {
                                                  let ArrayInfo = SystemInformation.AdvQuerySiti.FindResults(Results,"GetOrariAll");
                                                  if(ArrayInfo != undefined)
                                                  {
                                                    Self.ObjAllineamento.Dati = false
                                                    if (ArrayInfo.length > 0)
                                                    {
                                                      for (let i = 0; i < ArrayInfo.length; i++)
                                                      {
                                                        let Data = new Date(ArrayInfo[i].DATA)
                                                        let Ora = Data.getHours()
                                                        if (Ora < 10)
                                                          Ora = '0' + Ora
                                                        let Minuti = Data.getMinutes()
                                                        if (Minuti < 10)
                                                          Minuti = '0' + Minuti
                                                        Self.ObjAllineamento.ListaOre.push(Ora + ':' + Minuti)
                                                      }
                                                      if (Self.ObjAllineamento.ListaOre.length > 0)
                                                      {
                                                        Self.ObjAllineamento.OrarioAllineamento = Self.ObjAllineamento.ListaOre[0]
                                                        Self.ObjAllineamento.Dati = true
                                                      }
                                                    }
                                                  }
                                                  else SystemInformation.HandleError("Impossibile ottenere i dati della catena");
                                                  Self.InAttesaDeiDati = false
                                                },
                                                function(HTTPError,SubHTTPError)
                                                {
                                                  Self.InAttesaDeiDati = false
                                                  SystemInformation.HandleError(HTTPError,SubHTTPError)
                                                }, 
                                                'SelectOrariAllineamento');
      }
    },
  }
}
</script>